import React from 'react';
import { Link } from 'react-router-dom';

const primaryServices = [
  {
    number: '01',
    title: 'Managed Websites',
    text: 'Updates, security, backups, monitoring, and the everyday technical problems that come with running a website.',
    link: '/services/website-management',
    action: 'See website management'
  },
  {
    number: '02',
    title: 'Business Email and Hosting',
    text: 'Microsoft 365, Google Workspace, migrations, managed hosting, DNS, SSL, and help when essential systems stop behaving.',
    link: '/services/business-email',
    action: 'See email and hosting'
  },
  {
    number: '03',
    title: 'Technical Projects',
    text: 'New websites, redesigns, landing pages, integrations, migrations, and practical technical improvements.',
    link: '/services/web-design-and-development',
    action: 'See web services'
  }
];

const quieterServices = [
  ['Technical Support', '/services/technical-support'],
  ['Server management', '/services/technical-support#server-management'],
  ['Managed Hosting', '/services/managed-hosting'],
  ['Technology Consulting', '/services/technology-consulting']
];

const CoreServices = () => {
  return (
    <section className="bg-[#FAF8F3] py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <div className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
            One technical partner
          </div>
          <h2 className="max-w-5xl text-4xl leading-tight sm:text-5xl">
            The parts of your online setup that need someone paying attention.
          </h2>
          <p className="mt-6 max-w-2xl text-xl leading-relaxed text-[#17211E]/70">
            Start with one problem or bring the wider setup under one dependable
            relationship.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1.2fr_.8fr]">
          <div className="border border-[#174C3C] bg-[#174C3C] p-8 text-white sm:p-12">
            <div className="mb-20 text-sm font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
              Primary capability
            </div>
            <div className="text-7xl font-bold text-white/20">01</div>
            <h3 className="mt-3 text-4xl leading-tight">
              Website management that stays connected to the rest of the setup.
            </h3>
            <p className="mt-7 max-w-xl text-lg leading-relaxed text-white/75">
              Keep the website updated, secure, monitored, backed up, and
              supported by the same people who can look at the hosting, email,
              domains, and integrations around it.
            </p>
            <Link
              to="/services/website-management"
              className="mt-10 inline-block font-bold text-[#D7B77A] underline decoration-2 underline-offset-4"
            >
              See website management
            </Link>
          </div>

          <div className="grid gap-6">
            {primaryServices.slice(1).map((service) => (
              <Link
                key={service.number}
                to={service.link}
                className="border border-[#17211E]/15 bg-white p-8 transition-colors hover:border-[#174C3C]"
              >
                <div className="flex items-start justify-between gap-5">
                  <span className="text-sm font-bold text-[#D7B77A]">
                    {service.number}
                  </span>
                  <span className="text-2xl text-[#174C3C]">↗</span>
                </div>
                <h3 className="mt-12 text-3xl leading-tight">{service.title}</h3>
                <p className="mt-5 text-lg leading-relaxed text-[#17211E]/70">
                  {service.text}
                </p>
                <span className="mt-8 inline-block font-bold text-[#174C3C]">
                  {service.action}
                </span>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-4 border-t border-[#17211E]/15 pt-7">
          <span className="text-sm font-bold uppercase tracking-[0.18em] text-[#17211E]/50">
            Also available
          </span>
          {quieterServices.map(([label, link]) => (
            <Link key={label} to={link} className="home-link text-base">
              {label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreServices;